import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Segment } from 'semantic-ui-react';
import { SG_FETCH_ADMIN_PHASE_TRANSITION, SG_ADD_ADMIN_PHASE_TRANSITION, SG_EDIT_ADMIN_PHASE_TRANSITION } from 'constants/actions';

const PhaseTransitionAddEdit = () => {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const item = useSelector((state) => state.action_phase_transition?.[id] || null);

  const [form, setForm] = useState({ name: '', from_phase: '', to_phase: '', conditions: '' });

  useEffect(() => {
    if (isEdit && id) {
      dispatch({ type: SG_FETCH_ADMIN_PHASE_TRANSITION, payload: { id } });
    }
  }, [dispatch, id, isEdit]);

  useEffect(() => {
    if (item) setForm({ name: item.name || '', from_phase: item.from_phase || '', to_phase: item.to_phase || '', conditions: item.conditions || '' });
  }, [item]);

  const handleSubmit = () => {
    if (isEdit) {
      dispatch({ type: SG_EDIT_ADMIN_PHASE_TRANSITION, payload: { id, data: form } });
    } else {
      dispatch({ type: SG_ADD_ADMIN_PHASE_TRANSITION, payload: form });
    }
    navigate('../');
  };

  return (
    <Segment>
      <h2>{isEdit ? 'Edit Phase Transition' : 'New Phase Transition'}</h2>
      <Form>
        <Form.Field>
          <label>Name</label>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </Form.Field>
        <Form.Field>
          <label>From Phase</label>
          <input value={form.from_phase} onChange={(e) => setForm({ ...form, from_phase: e.target.value })} />
        </Form.Field>
        <Form.Field>
          <label>To Phase</label>
          <input value={form.to_phase} onChange={(e) => setForm({ ...form, to_phase: e.target.value })} />
        </Form.Field>
        <Form.Field>
          <label>Conditions</label>
          <input value={form.conditions} onChange={(e) => setForm({ ...form, conditions: e.target.value })} />
        </Form.Field>
        <Button primary onClick={handleSubmit}>{isEdit ? 'Save' : 'Create'}</Button>
        <Button onClick={() => navigate('../')}>Cancel</Button>
      </Form>
    </Segment>
  );
};

export default PhaseTransitionAddEdit;
